export default __webpack_public_path__ + "static/media/Implantology.18f7bdd9.png";